import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const NavBarButton = ({
  children,
  text,
  setHasSubmenu,
  handleMenuOpen,
  setSubmenuList,
  submenuItems,
}) => {
  const handleClick = () => {
    setSubmenuList(submenuItems);
    setHasSubmenu(previousValue => !previousValue);

    return handleMenuOpen('submenu');
  };

  return (
    <S.Button onClick={handleClick}>
      {children}
      <S.ButtonText>{text}</S.ButtonText>
    </S.Button>
  );
};

export default NavBarButton;

NavBarButton.defaultProps = {
  submenuItems: [],
};

NavBarButton.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  setHasSubmenu: PropTypes.func.isRequired,
  handleMenuOpen: PropTypes.func.isRequired,
  setSubmenuList: PropTypes.func.isRequired,
  submenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      redirectTo: PropTypes.string,
      hasAccess: PropTypes.arrayOf(PropTypes.number),
    }),
  ),
};
